import { render, staticRenderFns } from "./DocumentsBatchListCreate.vue?vue&type=template&id=d01868da"
import script from "./DocumentsBatchListCreate.vue?vue&type=script&lang=js"
export * from "./DocumentsBatchListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports